<template>
  <div v-if="open">
    <Teleport to="body">
      <div
        v-if="open"
        class="modalWrapper fixed top-0 left-0 z-7000! h-full w-screen justify-center overflow-hidden"
        @click="closeModal()"
      >
        <transition name="wrapper" appear>
          <div
            v-if="open"
            :class="[
              'absolute top-0 left-0 flex h-screen w-screen items-center justify-center bg-neutral-950/70 px-6',
            ]"
          >
            <transition :name="'slide'" appear>
              <div
                v-if="open"
                :class="[
                  'bg-white-500 relative flex max-h-full max-w-screen overflow-hidden rounded-3xl',
                ]"
              >
                <div class="absolute top-2 right-4">
                  <TButton
                    type="tonal"
                    color="neutral"
                    icon="close"
                    @click="closeModal()"
                  />
                </div>
                <div @click.stop>
                  <UpgradeRequired :source="source" />
                </div>
              </div>
            </transition>
          </div>
        </transition>
      </div>
    </Teleport>
  </div>
</template>
<script setup lang="ts">
import { TButton } from '@teachino/shared-design-system';
import { type UpgradeSource } from '@teachino/shared-util';
import UpgradeRequired from './UpgradeRequired.vue';
defineProps<{
  open: boolean;
  source: UpgradeSource;
}>();

const emits = defineEmits<{ close: [] }>();

function closeModal(): void {
  emits('close');
}
</script>
